/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Promos02ScopeOptionsResponse } from '../../models/promos-02-scope-options-response';

export interface ApiV1PromosScopeOptionsGet$Params {
      body?: {
}
}

export function apiV1PromosScopeOptionsGet(http: HttpClient, rootUrl: string, params?: ApiV1PromosScopeOptionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Promos02ScopeOptionsResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1PromosScopeOptionsGet.PATH, 'get');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Promos02ScopeOptionsResponse>;
    })
  );
}

apiV1PromosScopeOptionsGet.PATH = '/api/v1/promos/scope-options';
